import React, { useEffect, useState } from 'react';
import { LaunchDarklyProvider } from '../launch-darkly-provider/LaunchDarklyProvider';
import { fetchLaunchDarklyClientConfig } from '../../fetch-data/fetch-launch-darkly-config';

interface LaunchDarklyWrapperProps {
  baseUrl?: string;
  children: React.ReactNode;
}

export const LaunchDarklyWrapper: React.FC<LaunchDarklyWrapperProps> = ({
  baseUrl,
  children,
}) => {
  const [clientId, setClientId] = useState<string>('');

  useEffect(() => {
    const fetchLDKey = async () => {
      try {
        const key = await fetchLaunchDarklyClientConfig(baseUrl);
        setClientId(key);
      } catch (error) {
        console.error('Failed to fetch LaunchDarkly client config:', error);
      }
    };
    fetchLDKey();
  }, [baseUrl]);

  return (
    <LaunchDarklyProvider clientId={clientId}>{children}</LaunchDarklyProvider>
  );
};
